import { render } from "./Courses.vue?vue&type=template&id=f852dc66&scoped=true"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"

import "./Courses.vue?vue&type=style&index=0&id=f852dc66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f852dc66"]])

export default __exports__